var Screens = {
    helpPanelShown:false,
    selectedCharacter:0,
    selectedBackground:0,
    selectedDifficulty:0,
    json:{},
    loadingScreen: function() {
        var screenJson = Screens.json.screens.loadingScreen;

        var container = new PIXI.Container();
        var bg = Widgets.createBackgroundAsset(screenJson.bg);
        var bar = Widgets.createAsset(screenJson.bar);
        // bar.texture.
        container.addChild(bg);
        container.addChild(bar);
        var mask = new PIXI.Graphics();
        mask.beginFill(0);
        mask.drawRect(0,-568,bar.width,1136);
        mask.endFill();
        mask.x = -bar.width/2;
        mask.x+=bar.x;
        mask.y+=bar.y;
        container.addChild(mask);
        bar.mask = mask;

        var updateFunc = function(){
            mask.scale.x = ccLoader.progress/100||0;
        };

        return {
            construct: container,
            color: screenJson.screenColour,
            update:updateFunc
        };
    },
    startScreen: function() {
        var screenJson = Screens.json.screens.startScreen;
        if (sound._loaded) {
            Interface.playMusic(Screens.json.audio.music.startScreen);
        }
        else {
            sound.onload = function () {
                Interface.playMusic(Screens.json.audio.music.startScreen);
            };
        }

        var container = new PIXI.Container();

        var bg = Widgets.createBackgroundAsset(screenJson.bg);

        var title = Widgets.createAsset(screenJson.title);

        var buttonStart = Widgets.createButtonAsset(screenJson.start_btn,function(){
            CC.WebApp.current.swapScreen(Screens.characterScreen());
        });

        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings,help_panel);
        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings,function(){settings_panel.show();});
        var screenItems = [bg,title,buttonStart,button_settings,settings_panel,help_panel];
        container.addChild(bg,title,buttonStart,button_settings,settings_panel,help_panel);

        var resizeFunc = function(w,h){
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if(item.resize){
                    item.resize(w,h);
                }
            }
        };

        var updateFunc = function(delta){
        };
        return {
            construct: container,
            color: screenJson.screenColour,
            update:updateFunc,
            resize: resizeFunc
        };
    },
    characterScreen: function() {
        var screenJson = Screens.json.screens.characterScreen;
        Interface.playMusic(Screens.json.audio.music.characterScreen);
        var record = localStorage.getItem(Screens.json.localStorageName);

        var container = new PIXI.Container();
        var bg = Widgets.createBackgroundAsset(screenJson.bg);

        var buttonTick = Widgets.createButtonAsset(screenJson.tick_btn,function(){
            Screens.selectedCharacter = carousel.currentPos;
            CC.WebApp.current.swapScreen(Screens[screenJson.nextScreen]());
        });
        var buttonPadlock = Widgets.createAsset(screenJson.padlock_btn);
        var padlockText = new PIXI.extras.BitmapText(0 + screenJson.padlock_text.copy,{font:"40px VAGRounded",tint:screenJson.padlock_text.tint});
        Widgets.setAssetParams(padlockText,screenJson.padlock_text);

        var updateButtonLockStatus = function(locked,score){
            buttonTick.visible = !locked;
            buttonPadlock.visible = locked;
            padlockText.visible = locked;
            if(locked){
                padlockText.text = score+screenJson.padlock_text.copy;
                padlockText.x = -padlockText.width/2
            }
        }.bind(this);
        var items = [];
        var screenItems = [];
        var item,title,i,character,itemJson;
        for(i = 0; i < screenJson.characters.length; ++i)
        {
            itemJson = screenJson.characters[i];
            item  = new PIXI.Container();
            character = Widgets.createAsset(itemJson.image);
            title = Widgets.createAsset(itemJson.title);
            item.addChild(character);
            item.addChild(title);
            if(itemJson.unlockScore && itemJson.unlockScore>record){
                item.locked = true;
                item.unlockScore = itemJson.unlockScore;
                var tintGraphic = new PIXI.Graphics();
                tintGraphic.beginFill(0,0.3);
                tintGraphic.drawRect(-320,-568,640,1136);
                tintGraphic.endFill();
                item.addChild(tintGraphic);
            }else{
                item.locked = false;
            }
            item.character = character;
            item.title = title;
            screenItems.push(title);
            item.hide = function(){
                this.title.alpha = 0;
            }.bind(item);
            item.show = function(){
                if(!this.locked){
                    this.title.alpha = 0;
                    this.title.scale.set(0.8);
                    TweenLite.to(this.title,0.2,{alpha:1});
                    TweenLite.to(this.title.scale,0.3,{x:1,y:1,ease:Back.easeOut});
                }
                updateButtonLockStatus(this.locked,this.unlockScore);
            }.bind(item);
            if(i==0){
                item.show();
            }else{
                item.hide();
            }
            items.push(item);
        }
        var carousel = Widgets.createSelectionCarousel(items,screenJson,0);
        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings,help_panel);
        var button_home = Widgets.createButtonAsset(Screens.json.ui.button_home,function(){CC.WebApp.current.swapScreen(Screens.startScreen())});
        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings,function(){settings_panel.show();});

        container.addChild(bg,carousel,buttonTick,buttonPadlock,padlockText,button_home,button_settings,settings_panel,help_panel);

        screenItems.push(bg,carousel,buttonTick,buttonPadlock,padlockText,button_home,button_settings,settings_panel,help_panel);

        var resizeFunc = function(w,h){
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if(item && item.resize){
                    item.resize(w,h);
                }
            }
        };

        var updateFunc = function(delta){

        };
        return {
            construct: container,
            color: 0xEEEEEE,
            update:updateFunc,
            resize:resizeFunc
        };
    },
    backgroundScreen: function() {
        var screenJson = Screens.json.screens.backgroundScreen;
        Interface.playMusic(Screens.json.audio.music.characterScreen);
        var record = localStorage.getItem(Screens.json.localStorageName);
        var container = new PIXI.Container();
        if(screenJson.bg){
            var bg = Widgets.createBackgroundAsset(screenJson.bg);
            container.addChild(bg);
        }
        var buttonTick = Widgets.createButtonAsset(screenJson.tick_btn,function(){
            // sound.play(Screens.json.audio.itemSelect);
            Screens.selectedBackground = carousel.currentPos;
            showDifficulty();

            // CC.WebApp.current.swapScreen(Screens[screenJson.nextScreen]());
        });
        var buttonPadlock = Widgets.createAsset(screenJson.padlock_btn);
        var padlockText = new PIXI.extras.BitmapText(0 + screenJson.padlock_text.copy,{font:"40px VAGRounded",tint:screenJson.padlock_text.tint});
        Widgets.setAssetParams(padlockText,screenJson.padlock_text);

        var updateButtonLockStatus = function(locked,score){
            buttonTick.visible = !locked;
            buttonPadlock.visible = locked;
            padlockText.visible = locked;
            if(locked){
                padlockText.text = score+screenJson.padlock_text.copy;
                padlockText.x = -padlockText.width/2
            }
        }.bind(this);

        var items = [];
        var item,i,itemJson;
        for(i = 0; i < screenJson.items.length; ++i)
        {
            itemJson = screenJson.items[i];
            item  = Widgets.createBackgroundAsset(itemJson.image);
            if(itemJson.unlockScore && itemJson.unlockScore>record){
                item.locked = true;
                item.unlockScore = itemJson.unlockScore;
                var tintGraphic = new PIXI.Graphics();
                tintGraphic.beginFill(0,0.3);
                tintGraphic.drawRect(-320,-568,640,1136);
                tintGraphic.endFill();
                item.addChild(tintGraphic);
            }else{
                item.locked = false;
            }

            item.hide = function(){
            }.bind(item);
            item.show = function(){
                updateButtonLockStatus(this.locked,this.unlockScore);
            }.bind(item);
            if(i==0){
                item.show();
            }else{
                item.hide();
            }
            items.push(item);
        }
        var carousel = Widgets.createSelectionCarousel(items,screenJson,0);
/*
        carousel.prev();
        TweenLite.delayedCall(0.31,carousel.prev,null,carousel);
        // carousel.prev();
*/

        TweenLite.from(items[0],1,{x:-640, ease: Bounce.easeOut,delay:0.3});
        TweenLite.from(items[1],1,{x:0, ease: Bounce.easeOut,delay:0.3});


        var clickBlocker = Widgets.createClickBlocker();

        var overlay_difficulty;
        if(screenJson.overlay_difficulty){
            overlay_difficulty = Widgets.createAsset(screenJson.overlay_difficulty);
        }else{
            overlay_difficulty = new PIXI.Container();
        }
        var easy_btn = Widgets.createButtonAsset(screenJson.easy_btn,function(){
            Screens.selectedDifficulty = 0;
            CC.WebApp.current.swapScreen(Screens[screenJson.nextScreen]());
        });
        overlay_difficulty.addChild(easy_btn);
        var hard_btn = Widgets.createButtonAsset(screenJson.hard_btn,function(){
            Screens.selectedDifficulty = 1;
            CC.WebApp.current.swapScreen(Screens[screenJson.nextScreen]());
        });
        overlay_difficulty.addChild(hard_btn);
        var showDifficulty = function(){
            container.addChild(clickBlocker);
            container.addChild(overlay_difficulty);
        };


        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings,help_panel);
        var button_home = Widgets.createButtonAsset(Screens.json.ui.button_home,function(){CC.WebApp.current.swapScreen(Screens.startScreen())});
        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings,function(){settings_panel.show();});
        container.addChild(carousel,buttonTick,buttonPadlock,padlockText,button_home,button_settings,settings_panel,help_panel);

        var screenItems = [carousel,buttonTick,buttonPadlock,padlockText,button_home,button_settings,settings_panel,help_panel];

        var resizeFunc = function(w,h){
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if(item.resize){
                    item.resize(w,h);
                }
            }
        };

        var updateFunc = function(delta){
        };
        return {
            construct: container,
            color: screenJson.screenColour,
            update:updateFunc,
            resize:resizeFunc
        };
    },
    gameScreen: function() {
        var screenJson = Screens.json.screens.gameScreen;
        Interface.playMusic(Screens.json.audio.music.gameScreen);
        var container = new PIXI.Container();
        var gameEndFunc = function(score){
            CC.WebApp.current.swapScreen(Screens.resultsScreen(score))
        };
        var jumpGame = new JumpGame(gameEndFunc,Screens.selectedCharacter,Screens.selectedBackground,Screens.selectedDifficulty,screenJson,Screens.json.audio);
        jumpGame.start();
        container.addChild(jumpGame);


        //UI
        var paused = false;
        var confirm_panel = Widgets.createConfirmationDialog(Screens.json.ui.panel_are_you_sure);
        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var closeFunction = function(){
            paused = false;
        }.bind(this);
        var pause_panel = Widgets.createPauseMenu(Screens.json.ui.panel_paused,help_panel,confirm_panel,closeFunction);
        var button_pause = Widgets.createButtonAsset(Screens.json.ui.button_pause,function(){pause_panel.show();paused =true},true);
        container.addChild(button_pause,pause_panel,help_panel,confirm_panel);
        //UI end

        var resizeFunc = function(w,h){
            button_pause.resize(w,h);
            pause_panel.resize(w,h);
        };

        var updateFunc = function(delta){
            if(!paused){
                jumpGame.update(delta);
            }
        };

        if(CC.isMobile && !Screens.helpPanelShown){
            paused = true;
            help_panel.show(closeFunction);
            Screens.helpPanelShown = true;
        }

        return {
            construct: container,
            color: screenJson.screenColour,
            update:updateFunc,
            resize:resizeFunc
        };
    },
    resultsScreen: function(score) {
        var screenJson = Screens.json.screens.resultsScreen;
        sound.play(Screens.json.audio.results_sting);
        if(Screens.json.audio.music.resultsScreen == ""){
            Interface.stopMusic();
        }else{
            Interface.playMusic(Screens.json.audio.music.resultsScreen);
        }

        var record = localStorage.getItem(Screens.json.localStorageName);
        if(record === null)
        {
            record = 0;
        }

        var newRecordImage = Widgets.createAsset(screenJson.new_record);
        var yourScoreImage = Widgets.createAsset(screenJson.your_score);
        if(record < score)
        {
            localStorage.setItem(Screens.json.localStorageName,score);
            newRecordImage.visible = true;
            yourScoreImage.visible = false;
        }else{
            newRecordImage.visible = false;
            yourScoreImage.visible = true;
        }

        var container = new PIXI.Container();
        container.addChild(Widgets.createBackgroundAsset(screenJson.bg));
        var prevRecord = Widgets.createAsset(screenJson.rewards_previous);

        var tempScoreText = new PIXI.extras.BitmapText(score + "",{font:"250px VAGRoundedBig",tint:screenJson.record_text.tint});
        var tempRecordText = new PIXI.extras.BitmapText(record + "",{font:"60px VAGRoundedBig",tint:screenJson.record_text.tint});
        tempScoreText.y = -150;
        tempRecordText.x = 90;
        tempRecordText.y = 115;
        var seperation = 20;
        tempScoreText.x = -tempScoreText.textWidth/2;

        seperation = 10;
        distance = prevRecord.width + tempRecordText.width + seperation;
        prevRecord.y = 150;
        prevRecord.anchor.x = 0;
        prevRecord.x = -distance*0.5;
        tempRecordText.x = prevRecord.x+seperation+prevRecord.width;

        var button_home = Widgets.createButtonAsset(Screens.json.ui.button_home_alt,function(){CC.WebApp.current.swapScreen(Screens.startScreen())});
        var button_replay = Widgets.createButtonAsset(Screens.json.ui.button_replay,function(){CC.WebApp.current.swapScreen(Screens.gameScreen())});
        var continueFunction = function(){
            var characters = Screens.json.screens.characterScreen.characters;
            var backgrounds = Screens.json.screens.backgroundScreen.items;
            var unlockedItems = [];
            var obj;
            for (var i = 0; i < characters.length; i++) {
                obj = characters[i];
                if(obj.unlockScore){
                    if(record<obj.unlockScore && obj.unlockScore<=score){
                        obj.type = "character";
                        unlockedItems.push(obj);
                    }
                }
            }
            for (i = 0; i < backgrounds.length; i++) {
                obj = backgrounds[i];
                if(obj.unlockScore){
                    if(record<obj.unlockScore && obj.unlockScore<=score){
                        obj.type = "background";
                        unlockedItems.push(obj);
                    }
                }
            }
            if(unlockedItems.length>0){
                CC.WebApp.current.swapScreen(Screens.unlockScreen(unlockedItems));
            }else{
                CC.WebApp.current.swapScreen(Screens.characterScreen());
            }
        };
        var button_continue = Widgets.createButtonAsset(Screens.json.ui.button_continue,continueFunction);

        var help_panel = Widgets.createHelpPanel(Screens.json.ui.panel_help);
        var settings_panel = Widgets.createSettingsMenu(Screens.json.ui.panel_settings,help_panel);
        var button_settings = Widgets.createButtonAsset(Screens.json.ui.button_settings,function(){settings_panel.show();});

        var screenItems;
        if(record == 0){
            screenItems = [newRecordImage,yourScoreImage,tempScoreText,button_home,button_replay,button_continue,button_settings,settings_panel,help_panel];
            container.addChild(newRecordImage,yourScoreImage,tempScoreText,button_home,button_replay,button_continue,button_settings,settings_panel,help_panel);
        }else{
            screenItems = [newRecordImage,yourScoreImage,prevRecord,tempScoreText,tempRecordText,button_home,button_replay,button_continue,button_settings,settings_panel,help_panel];
            container.addChild(newRecordImage,yourScoreImage,prevRecord,tempScoreText,tempRecordText,button_home,button_replay,button_continue,button_settings,settings_panel,help_panel);
        }

        var resizeFunc = function(w,h){
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if(item.resize){
                    item.resize(w,h);
                }
            }
        };



        var updateFunc = function(delta){

        };
        return {
            construct: container,
            color: screenJson.screenColour,
            update:updateFunc,
            resize:resizeFunc
        };
    },
    unlockScreen: function(unlockedItems) {
        var screenJson = Screens.json.screens.unlockScreen;
        Interface.stopMusic();
        if(Screens.json.audio.music.resultsScreen != ""){
            Interface.playMusic(Screens.json.audio.music.unlockedItems);
        }

        sound.play(Screens.json.audio.unlock);

        var container = new PIXI.Container();

        var bg = Widgets.createBackgroundAsset(screenJson.bg);
        container.addChild(bg);

        var unlockContainer = new PIXI.Container();
        if(unlockedItems[0].type == "character") {
            unlockContainer.addChild(Widgets.createAsset(unlockedItems[0].image));
        }else{
            unlockContainer.addChild(Widgets.createBackgroundAsset(unlockedItems[0].image));
        }

        var title = Widgets.createAsset(screenJson.title);

        var index = 0;
        var continueFunction = function(){
            index++;
            if(unlockedItems.length==index){
                CC.WebApp.current.swapScreen(Screens.startScreen());
            }else{
                sound.play(Screens.json.audio.unlock);
                if(unlockContainer.children.length>0){
                    unlockContainer.removeChild(unlockContainer.children[0]);
                }
                if(unlockedItems[index].type == "character"){
                    unlockContainer.addChild(Widgets.createAsset(unlockedItems[index].image));
                }else {
                    unlockContainer.addChild(Widgets.createBackgroundAsset(unlockedItems[index].image));
                }
            }
        };

        var button_continue = Widgets.createButtonAsset(Screens.json.ui.button_continue_alt,continueFunction);
        container.addChild(unlockContainer,title,button_continue);

        var screenItems = [unlockContainer,title,button_continue];

        var resizeFunc = function(w,h){
            for (var i = 0; i < screenItems.length; i++) {
                var item = screenItems[i];
                if(item.resize){
                    item.resize(w,h);
                }
            }
        };

        var updateFunc = function(delta){
        };
        return {
            construct: container,
            color: 0xEEEEEE,
            update:updateFunc,
            resize: resizeFunc
        };
    }
};